import styled from 'styled-components';
// import { color } from 'styles/pallete';

export const container = styled.div<{ $backGroundColor: string }>`
	width: 100%;
	display: flex;
	align-items: center;
	flex-direction: column;
	justify-content: center;
	gap: 1rem;
	background-color: ${(props) => props.$backGroundColor};
	transition: all ease 0.5s;
`;

export const listProducts = styled.div<{ $isLoad: boolean }>`
	width: 100%;
	height: 400px;
	display: ${(props) => (props.$isLoad ? 'none' : 'flex')};
	align-items: center;
	justify-content: flex-start;
	gap: 1rem;
	overflow: hidden;
`;

export const product = styled.div`
	min-width: 60%;
	height: 100%;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	gap: 0.5rem;
`;

export const noBanners = styled.div`
	width: 100%;
	display: flex;
	align-items: center;
	justify-content: center;
	padding: 1rem;

	> p {
		font-size: 1.4rem;
		font-weight: 900;
	}
`;

export const load = styled.div`
	width: 100%;
	height: 100%;
	display: flex;
	align-items: center;
	justify-content: center;
	padding: 1rem;
`;
